const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

/* `label` is phrased to complete "Please enter …", e.g. "your full name". */
export function requiredText(value: string, label: string, min = 1): string | undefined {
  const trimmed = value.trim();
  if (!trimmed) return `Please enter ${label}.`;
  if (trimmed.length < min) return `Please add a little more detail (at least ${min} characters).`;
  return undefined;
}

/* `label` is phrased to complete "Please select …", e.g. "an industry". */
export function requiredChoice(value: string, label: string): string | undefined {
  return value ? undefined : `Please select ${label}.`;
}

export function emailError(value: string): string | undefined {
  if (!value.trim()) return 'Please enter your email address.';
  if (!isValidEmail(value)) return 'Please enter a valid email address, e.g. name@company.com.';
  return undefined;
}

export const ACCEPTED_CV_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
export const MAX_CV_BYTES = 5 * 1024 * 1024;

export function cvError(file: File | null): string | undefined {
  if (!file) return undefined;
  if (!ACCEPTED_CV_TYPES.includes(file.type)) return 'Please upload a PDF or Word document.';
  if (file.size > MAX_CV_BYTES) return 'Please upload a file smaller than 5 MB.';
  return undefined;
}

export function compactErrors<T extends string>(errors: Record<T, string | undefined>): Partial<Record<T, string>> {
  const result: Partial<Record<T, string>> = {};
  (Object.keys(errors) as T[]).forEach((key) => {
    const message = errors[key];
    if (message) result[key] = message;
  });
  return result;
}
